import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { pickBy } from 'lodash-es';
import { Fragment } from 'react';
import { initLD } from '../utils/initLaunchDarkly';
import { mark } from '../utils/perf';
import { renderRoot } from '../utils/render';
import { init as initSentry } from '../utils/sentry';
import { initTzdbObservability } from '../utils/tzdbObservability';
import { win } from '../utils/win';
import { App } from './harness/app';
import { connectCarrierConfig } from './harness/config';
import { getSelectedCustomer } from './harness/customer';
import './harness/newrelic';

mark('src/index/init');

/**
 * Loads the en-US locale catalog for Connect Carrier.
 * Connect Carrier only supports the default en-US locale.
 */
async function activateLocale(): Promise<void> {
  const { messages } = await import(`./locales/en-US.po`);
  i18n.load('en-US', messages);
  i18n.activate('en-US');
}

// This is to make fragment rendering work...jsxFactory issues with tsconfig
win.React = {
  Fragment,
};

initSentry();
initTzdbObservability();

(async (): Promise<void> => {
  await activateLocale();
  const LDProvider = await initLD({
    launchDarklyKey: connectCarrierConfig.launchDarklyKey,
    appName: 'connect-carrier-frontend',
    env: connectCarrierConfig.envKey,
    additionalContext: pickBy({
      tenant: getSelectedCustomer()?.tenantCode && {
        kind: 'tenant',
        name: getSelectedCustomer()?.tenantName,
        key: getSelectedCustomer()?.tenantCode,
      },
    }),
  });
  mark('src/index/render');
  renderRoot(
    <LDProvider>
      <I18nProvider i18n={i18n}>
        <App />
      </I18nProvider>
    </LDProvider>,
    // Connect apps always use the legacy React 17 engine for now (ME-413745).
    false,
  );
})();
